// src/modules/student-exit/pages/StudentExitPage.tsx
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
import PageHeader from "components/Common/PageHeader";
import { all_routes } from "router/all_routes";
// import CustomButton from "components/Common/ui/CustomButton";
import TableFilterDynamique, { FilterField } from "components/Common/TableFilter/TableFilterDynamique";
import useStudentExit from "../hooks/useStudentExit";
import StudentExitTable from "../components/StudentExitTable";
import useClassManagement from "feature-module/academic/classes/hooks/useClassManagement";
// import AddEditStudentExit from "../components/AddEditStudentExit";
// import { RootState } from "redux/store";
// import { useAbility } from "config/abilityContext";

const StudentExitPage: React.FC = () => {
  const { t } = useTranslation();
  const {
    studentExits,
    loading,
    fetchStudentExits,
    infoPagination,
    // handleCreate,
    // handleUpdate,
    handleApprove,
    handleReject,
    handleComplete,
    handleDelete,
    statusOptions,
    exitTypeOptions,
    // selectedStudentExit,
    // handleGetGuardianByStudentId,
    // handleGetAuthorizedByStudentId,
    fetchStudents,
    setSelectedStudentExit,
  } = useStudentExit();
  // const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  // const ability = useAbility();
  const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});
  // const [students, setStudents] = useState<any[]>([]);
    const { classes , fetchClasses } = useClassManagement();

  const breadcrumbItems = [
    { label: "dashboard", path: all_routes.dashboard },
    { label: "studentExit.title", active: true },
  ];

  const filterFields: FilterField[] = useMemo(
    () => [
      { key: "search", label: t("search"), type: "text" },
      { key: "classId", label: t("class"), type: "select", options: classes.map((c) => ({ label: c.name, value: c.id })) },
      { key: "status", label: t("studentExit.form.status"), type: "select", options: statusOptions },
      { key: "exitType", label: t("studentExit.form.exitType"), type: "select", options: exitTypeOptions },
      { key: "exitTime", label: t("studentExit.form.exitTime"), type: "range", rangeKeys: { start: "startDate", end: "endDate" } },
    ],
    [t, statusOptions, exitTypeOptions, classes]
  );



  // const handleSave = async (payload: any) => {
  //   try {
  //     let result = false;

  //     if (selectedStudentExit?.id) {
  //       result = await handleUpdate(selectedStudentExit.id, payload);
  //     } else {
  //       result = await handleCreate(payload);
  //     }

  //     if (result) {
  //       setSelectedStudentExit(null);
  //       refetchData();
  //     }
  //     return result;
  //   } catch (error) {
  //     console.error("Error saving student exit:", error);
  //     return false;
  //   }
  // };

  const handleFilter = (newFilters: { [key: string]: any }) => {
    setFilters(newFilters);
    refetchData(newFilters);
  };

  const refetchData = (currentFilters = filters) => {
    const params = {
      ...currentFilters,
      page: 1,
      limit: 10,
    };

    fetchStudentExits(params);
  };



  // const handleAddNew = () => {
  //   setSelectedStudentExit(null);
  //   setIsModalOpen(true);
  // };

  // const handleEdit = (studentExit: any) => {
  //   setSelectedStudentExit(studentExit);
  //   setIsModalOpen(true);
  // };



  // const handleCloseModal = () => {
  //   setSelectedStudentExit(null);
  //   setIsModalOpen(false);
  // };

  const handleApproveExit = async (id: string) => {
    const result = await handleApprove(id);
    if (result) {
      refetchData();
    }
  };

  const handleRejectExit = async (id: string) => {
    const result = await handleReject(id);
    if (result) {
      refetchData();
    }
  };

  const handleCompleteExit = async (id: string) => {
    const result = await handleComplete(id);
    if (result) {
      refetchData();
    }
  };

  const handleDeleteExit = async (id: string) => {
    const result = await handleDelete(id);
    if (result) {
      refetchData();
    }
  };

  useEffect(() => {
    fetchStudentExits({ page: 1, limit: 10 });
    fetchClasses();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader title={t("studentExit.title")} breadcrumbItems={breadcrumbItems} />

        <div className="d-flex mb-3 justify-content-end gap-2">

          <TableFilterDynamique
            fields={filterFields}
            filters={filters}
            onApply={handleFilter}
            onReset={() => handleFilter({ page: 1, limit: 10 })}
          />
          {/* {ability.can("create", "StudentExit") && (
            <CustomButton
              onClick={handleAddNew}
            >
              <i className="ti ti-plus me-2" />
              {t("studentExit.add")}
            </CustomButton>
          )} */}
        </div>

        <StudentExitTable
          dataSource={studentExits}
          loading={loading}
          // onEdit={handleEdit}
          onApprove={handleApproveExit}
          onReject={handleRejectExit}
          onComplete={handleCompleteExit}
          onDelete={handleDeleteExit}
          dataPaginate={{
            current: infoPagination?.page,
            pageSize: infoPagination?.limit,
            total: infoPagination?.total,
          }}
          onChange={(pg) => {
            const params = {
              ...filters,
              page: pg.current!,
              limit: pg.pageSize!,
            };
            fetchStudentExits(params);
          }}
        />

        {/* <AddEditStudentExit
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onSave={handleSave}
          students={students}
          selectedStudentExit={selectedStudentExit}
          onGetGuardianByStudentId={handleGetGuardianByStudentId}
          onGetAuthorizedByStudentId={handleGetAuthorizedByStudentId}
        /> */}
      </div>
    </div>
  );
};

export default StudentExitPage;